import { Typography } from "@mui/material";
import { MerchantTransactionItem } from "Components/Shared/Transactions/MerchantTransactionItem/MerchantTransactionItem";
import { TransactionItem } from "Components/Shared/Transactions/TransactionItem/TransactionItem";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import type { TransactionItem as TransactionItemType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { getTransactionDirection } from "Utils/TransactionUtils";

type Props = {
  transactions: Array<TransactionItemType>;
  variant: "merchant" | "customer";
};

export const TransactionItems = ({ transactions, variant }: Props) => {
  const { t } = useResource();
  const user = useLoggedInUser();

  const isMerchant = variant === "merchant";
  const currentUserID = user?.userID || -1; // We should always have UserID at this point

  if (!transactions.length) {
    return (
      <Typography marginTop={({ spacing }) => spacing(2)}>
        {t(Resources.Components.Transactions.NoTransactions)}
      </Typography>
    );
  }

  return (
    <>
      {transactions.map((transaction) =>
        isMerchant ? (
          <MerchantTransactionItem
            key={transaction.publicID}
            item={transaction}
            direction={getTransactionDirection(transaction, currentUserID)}
          />
        ) : (
          <TransactionItem
            key={transaction.publicID}
            item={transaction}
            direction={getTransactionDirection(transaction, currentUserID)}
          />
        ),
      )}
    </>
  );
};
